import { render, staticRenderFns } from "./404Block.vue?vue&type=template&id=a16703ec&scoped=true"
import script from "./404Block.vue?vue&type=script&setup=true&lang=js"
export * from "./404Block.vue?vue&type=script&setup=true&lang=js"
import style0 from "./404Block.vue?vue&type=style&index=0&id=a16703ec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16703ec",
  null
  
)

export default component.exports